import {
  CHANGE_NOTIFICATION_SETTINGS,
  GET_ALL_NOTIFICATIONS,
  GET_BRANDS,
  GET_CURRENT_SUB,
  LOGIN_USER,
  SET_ACTIVE_ACCOUNT,
  SET_ALERT_DETAILS,
  SET_BRAND_DETAILS,
  SET_AI_BRAND_INFO,
  SET_EDIT_DRAFT_DATA,
  SET_EDIT_POST_DATA,
  SET_LATEST_NOTIFICATIONS,
  SET_LOGGED_IN,
  SET_REDIRECT_URL,
  SET_SCHEDULE_DATA,
  SET_TIMEZONES,
  SET_USER,
  SET_USER_ACCOUNTS,
  SHOW_NOTIFICATIONS_BADGE,
  SHOW_DMS_BADGE,
  SHOW_COMMENTS_BADGE,
  SET_NEW_NOTIFICATION,
  SET_NEW_CONVERSATIONS,
  SET_NEW_POST_STATUS,
  TOGGLE_EXPIRED_BANNER,
  GET_PLANS,
  SET_PAGE_TITLE,
  SET_MEMBER,
  GET_MEMBERS,
  GET_INVITES,
  RESET,
  GET_TOOLTIP,
  GET_BANKS,
  GET_DEBIT_CARDS,
  SET_PLANNER,
  SET_SHOW_APP_MODAL,
} from "./actions/types";

export const initialState = {
  api_host: process.env.REACT_APP_API_HOST,
  ai_base_url: process.env.REACT_APP_AI_HOST,
  redirect_url: null,
  user: null,
  user_accounts: null,
  user_token: null,
  refresh_token: null,
  active_account: null,
  logged_in: false,
  timezones: [],
  brands: [],
  schedule_data: null,
  edit_post_data: null,
  edit_draft_data: null,
  brand: null,
  planner: null,
  ai_brand_info: null,
  notification_settings: 0,
  current_sub: null,
  notifications_badge: false,
  dms_badge: false,
  comments_badge: false,
  new_notification: null,
  new_conversations: {},
  new_post_status: false,
  latest_notifications: null,
  all_notifications: [],
  alert_details: null,
  expired_banner_display: true,
  plans: [],
  member: null,
  all_members: [],
  invites: [],
  page_title: null,
  guided_tours: {},
  debit_cards: [],
  banks: [],
  show_app_modal: false,
};

export default function rootReducer(state = initialState, action) {
  switch (action.type) {
    case RESET:
      return initialState;
    case LOGIN_USER:
      const { user, token, refresh_token, expires_in } = action.payload;

      return {
        ...state,
        user: user,
        user_token: token,
        refresh_token: refresh_token,
        logged_in: true,
        expires_in: expires_in,
      };
    case SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case SET_USER_ACCOUNTS:
      return {
        ...state,
        user_accounts: action.payload,
      };
    case SET_LOGGED_IN:
      return {
        ...state,
        logged_in: action.payload,
      };
    case SET_ACTIVE_ACCOUNT:
      return {
        ...state,
        active_account: action.payload,
      };
    case SET_TIMEZONES:
      return {
        ...state,
        timezones: action.payload,
      };
    case GET_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case SET_SCHEDULE_DATA:
      return {
        ...state,
        schedule_data: action.payload,
      };
    case SET_BRAND_DETAILS:
      return {
        ...state,
        brand: action.payload,
      };
    case SET_PLANNER:
      return {
        ...state,
        planner: action.payload,
      };
    case SET_EDIT_POST_DATA:
      return {
        ...state,
        edit_post_data: action.payload,
      };
    case SET_EDIT_DRAFT_DATA:
      return {
        ...state,
        edit_draft_data: action.payload,
      };
    case CHANGE_NOTIFICATION_SETTINGS:
      return {
        ...state,
        notification_settings: action.payload,
      };
    case SET_REDIRECT_URL:
      return {
        ...state,
        redirect_url: action.payload,
      };
    case GET_CURRENT_SUB:
      return {
        ...state,
        current_sub: action.payload,
      };
    case SET_NEW_POST_STATUS:
      return {
        ...state,
        new_post_status: action.payload,
      };
    case SHOW_NOTIFICATIONS_BADGE:
      return {
        ...state,
        notifications_badge: action.payload,
      };
    case SHOW_DMS_BADGE:
      return {
        ...state,
        dms_badge: action.payload,
      };
    case SHOW_COMMENTS_BADGE:
      return {
        ...state,
        comments_badge: action.payload,
      };
    case SET_NEW_NOTIFICATION:
      return {
        ...state,
        new_notification: action.payload,
      };
    case SET_NEW_CONVERSATIONS:
      return {
        ...state,
        new_conversations: action.payload,
      };
    case SET_LATEST_NOTIFICATIONS:
      return {
        ...state,
        latest_notifications: action.payload,
      };
    case GET_ALL_NOTIFICATIONS:
      return {
        ...state,
        all_notifications: action.payload,
      };
    case SET_ALERT_DETAILS:
      return {
        ...state,
        alert_details: action.payload,
      };
    case TOGGLE_EXPIRED_BANNER:
      return {
        ...state,
        expired_banner_display: action.payload,
      };
    case GET_PLANS:
      return {
        ...state,
        plans: action.payload,
      };
    case SET_PAGE_TITLE:
      return {
        ...state,
        page_title: action.payload,
      };
    case SET_MEMBER:
      return {
        ...state,
        member: action.payload,
      };
    case GET_MEMBERS:
      return {
        ...state,
        all_members: action.payload,
      };
    case GET_INVITES:
      return {
        ...state,
        invites: action.payload,
      };
    case GET_TOOLTIP:
      return {
        ...state,
        guided_tours: {
          ...action.payload,
        },
      };
    case SET_AI_BRAND_INFO:
      return {
        ...state,
        ai_brand_info: action.payload,
      };
    case GET_DEBIT_CARDS:
      return {
        ...state,
        debit_cards: action.payload,
      };
    case GET_BANKS:
      return {
        ...state,
        banks: action.payload,
      };
    case SET_SHOW_APP_MODAL:
      return {
        ...state,
        show_app_modal: action.payload,
      };
    default:
      return state;
  }
}
